'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Divider = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssThemr = require('react-css-themr');

var _identifiers = require('../../identifiers');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Divider = function (_React$Component) {
  _inherits(Divider, _React$Component);

  function Divider() {
    _classCallCheck(this, Divider);

    return _possibleConstructorReturn(this, (Divider.__proto__ || Object.getPrototypeOf(Divider)).apply(this, arguments));
  }

  _createClass(Divider, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          theme = _props.theme,
          hidden = _props.hidden,
          narrow = _props.narrow,
          thin = _props.thin,
          spacing = _props.spacing,
          dashed = _props.dashed,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['theme', 'hidden', 'narrow', 'thin', 'spacing', 'dashed', 'className']);

      var dividerClassName = (0, _classnames2['default'])(theme.divider, className, theme[spacing], (_classNames = {}, _defineProperty(_classNames, theme.hidden, hidden), _defineProperty(_classNames, theme.dashed, dashed), _defineProperty(_classNames, theme.narrow, narrow), _defineProperty(_classNames, theme.thin, thin), _classNames));
      return _react2['default'].createElement('div', _extends({
        className: dividerClassName
      }, rest), '\xA0');
    }
  }]);

  return Divider;
}(_react2['default'].Component);

Divider.themeShape = {
  divider: _propTypes2['default'].string.isRequired,
  hidden: _propTypes2['default'].string.isRequired,
  narrow: _propTypes2['default'].string.isRequired,
  none: _propTypes2['default'].string.isRequired,
  tiny: _propTypes2['default'].string.isRequired,
  small: _propTypes2['default'].string.isRequired,
  normal: _propTypes2['default'].string.isRequired,
  medium: _propTypes2['default'].string.isRequired,
  large: _propTypes2['default'].string.isRequired,
  xLarge: _propTypes2['default'].string.isRequired
};
Divider.propTypes = {
  theme: _propTypes2['default'].shape(Divider.themeShape).isRequired,
  className: _propTypes2['default'].string,
  hidden: _propTypes2['default'].bool,
  dashed: _propTypes2['default'].bool,
  narrow: _propTypes2['default'].bool,
  // TODO: remove (also in lemon tool); use spacing instead
  thin: _propTypes2['default'].bool,
  // TODO: remove (also in lemon tool); use spacing instead
  spacing: _propTypes2['default'].oneOf(['none', 'tiny', 'xxSmall', 'xSmall', 'small', 'normal', 'medium', 'large', 'xLarge'])
};
Divider.defaultProps = {
  hidden: false,
  narrow: false
};
exports['default'] = (0, _reactCssThemr.themr)(_identifiers.DIVIDER)(Divider);
exports.Divider = Divider;